import { styled } from '../../Utilities';
import { getStyles } from './HoverCard.styles';
import { HoverCardBase } from './HoverCard.base';
export var HoverCard = styled(HoverCardBase, getStyles, undefined, {
    scope: 'HoverCard'
});
//# sourceMappingURL=HoverCard.js.map